import React, { useState, useEffect } from "react";
import {
  Container,
  Background,
  Hr,
  Titulo,
  Button,
  Input,
  Row,
  Table,
} from "./style";
import api from "../../../services/api";
import { Swal, Toast } from "../../../services/SwalTemplates";
import Pagination from "../../../components/Pagination";
import ModalRegister from "../../../components/Modal/Rh/DefineCoord/Define";
import ModalEdit from "../../../components/Modal/Rh/DefineCoord/Edit";
import { IoPencilOutline, IoTrashOutline } from "react-icons/io5";
import { isAuthenticatedDev } from "../../../auth";

export default function CoordenadorSec() {
  const [showModalRegister, setShowModalRegister] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [usuario, setUsuario] = useState([]);
  const [searchCoord, setSearchCoord] = useState("");
  const [searchUnidade, setSearchUnidade] = useState("");
  const [searchCurso, setSearchCurso] = useState("");
  const [searchCC, setSearchCC] = useState("");

  useEffect(() => {
    const search = {
      searchCoord,
      searchUnidade,
      searchCurso,
      searchCC,
    };
    // Converta o objeto para JSON string e codifique para URL
    const searchParams = encodeURIComponent(JSON.stringify(search));
    api.get(`/rh/definicaocoord?search=${searchParams}&dev=${isAuthenticatedDev()}&perfil=${`COORD`}`)
      .then((response) => {
        setUsuarios(response.data.cursos_unidades);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, [searchCoord, searchCurso, searchCC, searchUnidade]);

  useEffect(() => {
    setTotalPages(Math.ceil(usuarios.length / 15));
  }, [usuarios]);

  

  return (
    <Background>
      <Container>
        <Titulo>Definição de Coordenador por Curso</Titulo>
        <Hr />
        <Row>
          <Input>
            <input
              value={searchCoord}
              onChange={(e) => {
                setSearchCoord(e.target.value.toUpperCase());
                setPage(1);
              }}
              type="search"
              placeholder="Pesquisar coordenador..."
            />
            <input
              value={searchUnidade}
              onChange={(e) => {
                setSearchUnidade(e.target.value.toUpperCase());
                setPage(1);
              }}
              type="search"
              placeholder="Pesquisar unidade..."
            />
            <input
              value={searchCurso}
              onChange={(e) => {
                setSearchCurso(e.target.value.toUpperCase());
                setPage(1);
              }}
              type="search"
              placeholder="Pesquisar curso..."
            />
            <input
              value={searchCC}
              onChange={(e) => {
                setSearchCC(e.target.value.toUpperCase());
                setPage(1);
              }}
              type="search"
              placeholder="Pesquisar c.c. ..."
            />
          </Input>
        </Row>
        <Table>
          <table>
            <thead>
              <tr>
                <th>Coord</th>
                <th>Unidade</th>
                <th>Curso</th>
                <th>C.C.</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.slice((page - 1) * 15, page * 15).map((u, i) => (
                <tr key={i}>
                  <td
                    data-title="Coord"
                    value={u.coordenadores}
                    className="td-left"
                    title={u.id_coordenador}
                  >
                    {u.coordenadores}
                  </td>
                  <td
                    data-title="Unidade"
                    value={u.unidade.substring(0, 20) + "..."}
                    className="td-left"
                    title={u.id_unidade}
                  >
                    {u.unidade}
                  </td>
                  <td data-title="Curso" value={u.curso} className="td-left" title={u.id_curso}>
                    {u.curso
                      .replaceAll("TÉCNICO EM ", "")
                      .replaceAll("TECNÓLOGO EM ", "")}
                  </td>
                  {/* Talvez deixar só o número do centro de custo */}
                  <td data-title="Centro Custo" value={u.centro_custo} title={u.id_centro_custo}>
                    {u.centro_custo
                      .replaceAll("CURSO TÉCNICO ", "")
                      .replaceAll("TECNÓLOGO EM ", "")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Table>
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
      </Container>
    </Background>
  );
}
